import { ApolloClient, HttpLink, InMemoryCache } from "@apollo/client";

export const apolloClient = new ApolloClient({
  link: new HttpLink({
    uri: "/graphql",
    credentials: "include",
  }),
  // ClientMembershipInline is a value object flattened from a client_people
  // row: its `id` is the CLIENT's id while `isPrimary` belongs to the
  // (client, person) MEMBERSHIP. Under default normalization every person's
  // membership in the same client collapses into one cache entry, so
  // isPrimary is overwritten by whichever person was written last and every
  // member of a multi-person client renders the same PRIMARY chip. Keep it
  // embedded in its parent Person instead of normalizing it.
  cache: new InMemoryCache({
    typePolicies: { ClientMembershipInline: { keyFields: false } },
  }),
});
